module.exports = __webpack_public_path__ + "static/media/plus_circular.60d3c6d5.svg";